import { useMutation, useQueryClient } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useUpdateSkillDimension = () => {
  const queryClient = useQueryClient();
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useMutation({
    mutationFn: async ({ id, input }) => {
      const result = await restClient({
        url: `${prefix}/skill-dimension/${id}`,
        method: 'PUT',
        data: input
      });
      return result;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['skillDimensions']);
    }
  });
};
